import DealStageType from "@mapmycustomers/shared/enum/DealStageType";
import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

const isClosedStage = (stage: Stage) =>
  [DealStageType.LOST, DealStageType.WON].includes(stage.type);

export default isClosedStage;
